"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const stockpile_types_1 = require("./stockpile.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataBrand: [],
    dataDropdown: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        checkpoint_id: '',
        checkpoint_name: '',
        brand1_name: '',
        brand2_name: '',
        brand3_name: '',
        brand4_name: '',
        brand5_name: '',
        brand2_disable: false,
        brand3_disable: false,
        brand4_disable: false,
        brand5_disable: false,
        inEdit: false,
        modified_by: '',
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'checkpoint_name', dir: 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'type', operator: 'contains', value: 'stockpile' }]
        }
    }
};
const stockpileConfigReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [stockpile_types_1.stockpileConfigTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        const brand_default = [{
                id: '',
                code: '',
                name: '-',
                is_active: true,
                created_by: '',
                created_date: new Date(),
                modified_by: '',
                modified_date: new Date()
            }];
        const newDataBrand = state.dataBrand.filter(item => {
            return item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand1_name) &&
                item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand2_name) &&
                item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand3_name) &&
                item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand4_name) &&
                item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand5_name);
        });
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataDropdown: brand_default.concat(newDataBrand), dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [stockpile_types_1.stockpileConfigTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [stockpile_types_1.stockpileConfigTypes.SET_DATA_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataBrand: action.payload.dataBrand, dataDropdown: action.payload.dataBrand });
    },
    [stockpile_types_1.stockpileConfigTypes.ON_ENTER_EDIT_CLICK]: (state, action) => {
        const { dataBrand, dataGrid, mutationMode, dataItem } = action.payload;
        const brand_default = {
            id: '',
            code: '',
            name: '',
            is_active: true,
            created_by: '',
            created_date: new Date(),
            modified_by: '',
            modified_date: new Date()
        };
        const brand1_data = dataBrand.find(item => item.name === dataItem.brand1_name) || brand_default;
        const brand2_data = dataBrand.find(item => item.name === dataItem.brand2_name) || brand_default;
        const brand3_data = dataBrand.find(item => item.name === dataItem.brand3_name) || brand_default;
        const brand4_data = dataBrand.find(item => item.name === dataItem.brand4_name) || brand_default;
        const brand5_data = dataBrand.find(item => item.name === dataItem.brand5_name) || brand_default;
        const newDataDropdown = state.dataBrand.filter(item => {
            return item.name !== dataItem.brand1_name &&
                item.name !== dataItem.brand2_name &&
                item.name !== dataItem.brand3_name &&
                item.name !== dataItem.brand4_name &&
                item.name !== dataItem.brand5_name;
        });
        const newDataItem = Object.assign(Object.assign({}, dataItem), { brand1_data,
            brand2_data,
            brand3_data,
            brand4_data,
            brand5_data, brand1_name: brand1_data.name, brand2_name: brand2_data.name, brand3_name: brand3_data.name, brand4_name: brand4_data.name, brand5_name: brand5_data.name });
        return Object.assign(Object.assign({}, state), { dataGrid,
            mutationMode, dataItem: mutationMode ? newDataItem : initialState.dataItem, dataDropdown: mutationMode ? [Object.assign(Object.assign({}, brand_default), { id: '', name: '-' })].concat(newDataDropdown) : state.dataDropdown });
    },
});
exports.default = stockpileConfigReducer;
